const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.1333 2.00004C10.1333 1.63185 10.4317 1.33337 10.7999 1.33337H13.9999C14.3681 1.33337 14.6666 1.63185 14.6666 2.00004V5.20004C14.6666 5.56823 14.3681 5.86671 13.9999 5.86671C13.6317 5.86671 13.3333 5.56823 13.3333 5.20004V3.60952L10.4713 6.47145C10.211 6.7318 9.78886 6.7318 9.52851 6.47145C9.26816 6.2111 9.26816 5.78899 9.52851 5.52864L12.3904 2.66671H10.7999C10.4317 2.66671 10.1333 2.36823 10.1333 2.00004Z"
        fill="#313131"
      />
      <path
        d="M6.47132 10.4714C6.73167 10.2111 6.73167 9.78899 6.47132 9.52864C6.21097 9.26829 5.78886 9.26829 5.52851 9.52864L2.66659 12.3906V10.8C2.66659 10.4319 2.36811 10.1334 1.99992 10.1334C1.63173 10.1334 1.33325 10.4319 1.33325 10.8V14C1.33325 14.3682 1.63173 14.6667 1.99992 14.6667H5.19992C5.56811 14.6667 5.86659 14.3682 5.86659 14C5.86659 13.6319 5.56811 13.3334 5.19992 13.3334H3.60939L6.47132 10.4714Z"
        fill="#313131"
      />
      <path
        d="M10.4713 9.52864C10.211 9.26829 9.78886 9.26829 9.52851 9.52864C9.26816 9.78899 9.26816 10.2111 9.52851 10.4714L12.3904 13.3334H10.7999C10.4317 13.3334 10.1333 13.6319 10.1333 14C10.1333 14.3682 10.4317 14.6667 10.7999 14.6667H13.9999C14.3681 14.6667 14.6666 14.3682 14.6666 14V10.8C14.6666 10.4319 14.3681 10.1334 13.9999 10.1334C13.6317 10.1334 13.3333 10.4319 13.3333 10.8V12.3906L10.4713 9.52864Z"
        fill="#313131"
      />
      <path
        d="M1.99992 1.33337C1.63173 1.33337 1.33325 1.63185 1.33325 2.00004V5.20004C1.33325 5.56823 1.63173 5.86671 1.99992 5.86671C2.36811 5.86671 2.66659 5.56823 2.66659 5.20004V3.60952L5.52851 6.47145C5.78886 6.7318 6.21097 6.7318 6.47132 6.47145C6.73167 6.2111 6.73167 5.78899 6.47132 5.52864L3.60939 2.66671H5.19992C5.56811 2.66671 5.86659 2.36823 5.86659 2.00004C5.86659 1.63185 5.56811 1.33337 5.19992 1.33337H1.99992Z"
        fill="#313131"
      />
    </svg>
  );
};

export default ExpandIcon;
